/* Xceed Towels 2026 (Pixelate). Behaviour for the xt- sections. No library, no jQuery.
   1. Scroll reveals ([data-reveal]) via IntersectionObserver; shown at once under reduced motion,
      in the theme editor, or without IntersectionObserver.
   2. <xt-filmstrip>: the custom-work strip. Images are fetched only as the strip approaches the
      viewport, then the row is cloned once so a translateX(-50%) loop is seamless. Pause control.
      Static and hand-scrollable under reduced motion and in the theme editor.
   3. <xt-slider>: the feedback scroll-snap slider. Previous, next and Pause; a 7 s auto-advance
      that holds while hovered, focused, touched or in a hidden tab, and never runs under reduced
      motion or in the theme editor.
   Transform and opacity only. Nothing here touches the LCP image. */
(function () {
  'use strict';

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduced() {
    return reduceQuery.matches;
  }
  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /* 1. Reveals */
  var revealObserver = null;
  function initReveals(root) {
    var targets = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (!targets.length) return;
    if (reduced() || designMode() || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
      );
    }
    targets.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveals(document);
    });
  } else {
    initReveals(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initReveals(event.target);
  });

  /* 2. Filmstrip */
  if (!customElements.get('xt-filmstrip')) {
    customElements.define(
      'xt-filmstrip',
      class XtFilmstrip extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('.xt-strip__list');
          this.pauseButton = this.querySelector('.xt-strip__pause');
          if (!this.list || this.dataset.layout === 'grid' || reduced() || designMode()) return;

          this.onPause = this.onPause.bind(this);
          if (this.pauseButton) this.pauseButton.addEventListener('click', this.onPause);

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              function (entries) {
                if (entries.some(function (e) { return e.isIntersecting; })) {
                  this.observer.disconnect();
                  this.start();
                }
              }.bind(this),
              { rootMargin: '600px 0px' }
            );
            this.observer.observe(this);
          } else {
            this.start();
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
          if (this.pauseButton) this.pauseButton.removeEventListener('click', this.onPause);
        }

        start() {
          if (this.started) return;
          this.started = true;
          var items = Array.prototype.slice.call(this.list.children);
          items.forEach(function (item) {
            var img = item.querySelector('img');
            if (img) img.loading = 'eager';
          });
          items.forEach(
            function (item) {
              var copy = item.cloneNode(true);
              copy.setAttribute('aria-hidden', 'true');
              copy.querySelectorAll('img').forEach(function (img) {
                img.alt = '';
              });
              this.list.appendChild(copy);
            }.bind(this)
          );
          this.classList.add('is-drifting');
        }

        onPause() {
          var paused = this.classList.toggle('is-paused');
          this.pauseButton.classList.toggle('is-active', paused);
          this.pauseButton.textContent = paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        }
      }
    );
  }

  /* 3. Feedback slider */
  if (!customElements.get('xt-slider')) {
    customElements.define(
      'xt-slider',
      class XtSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.xt-slider__track');
          if (!this.track) return;
          this.slides = Array.prototype.slice.call(this.track.querySelectorAll('.xt-slide'));
          this.count = this.slides.length;
          if (!this.count) return;
          this.index = 0;
          this.hovering = false;
          this.touchedUntil = 0;
          this.userPaused = false;
          this.pauseButton = this.querySelector('.xt-slider__pause');
          this.region = this.querySelector('.xt-slider__outer') || this;

          this.onArrow = this.onArrow.bind(this);
          this.onPause = this.onPause.bind(this);
          this.onScroll = this.onScroll.bind(this);
          this.onEnter = function () { this.hovering = true; }.bind(this);
          this.onLeave = function () { this.hovering = false; }.bind(this);
          this.onTouch = function () { this.touchedUntil = Date.now() + 12000; }.bind(this);
          this.onBlockSelect = this.onBlockSelect.bind(this);

          this.querySelectorAll('[data-slider-dir]').forEach(
            function (button) {
              button.addEventListener('click', this.onArrow);
            }.bind(this)
          );
          if (this.pauseButton) this.pauseButton.addEventListener('click', this.onPause);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          this.region.addEventListener('mouseenter', this.onEnter);
          this.region.addEventListener('mouseleave', this.onLeave);
          this.region.addEventListener('focusin', this.onEnter);
          this.region.addEventListener('focusout', this.onLeave);
          this.track.addEventListener('touchstart', this.onTouch, { passive: true });
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          if (reduced() || designMode()) {
            if (this.pauseButton) this.pauseButton.hidden = true;
            return;
          }
          this.timer = window.setInterval(
            function () {
              if (this.userPaused || this.hovering || document.hidden || Date.now() < this.touchedUntil) return;
              this.goTo(this.index + 1);
            }.bind(this),
            7000
          );
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        offsetOf(i) {
          return this.slides[i].offsetLeft - this.slides[0].offsetLeft;
        }

        goTo(i) {
          this.index = (i + this.count) % this.count;
          this.track.scrollTo({ left: Math.round(this.offsetOf(this.index)), behavior: reduced() ? 'auto' : 'smooth' });
        }

        onArrow(event) {
          this.touchedUntil = Date.now() + 12000;
          var dir = parseInt(event.currentTarget.getAttribute('data-slider-dir'), 10) || 1;
          this.goTo(this.index + dir);
        }

        onPause() {
          this.userPaused = !this.userPaused;
          this.pauseButton.classList.toggle('is-active', this.userPaused);
          this.pauseButton.textContent = this.userPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
        }

        onScroll() {
          window.clearTimeout(this.settle);
          this.settle = window.setTimeout(
            function () {
              var left = this.track.scrollLeft;
              var best = 0;
              var bestDistance = Infinity;
              for (var i = 0; i < this.count; i++) {
                var distance = Math.abs(this.offsetOf(i) - left);
                if (distance < bestDistance) {
                  bestDistance = distance;
                  best = i;
                }
              }
              this.index = best;
            }.bind(this),
            120
          );
        }

        onBlockSelect(event) {
          var i = this.slides.indexOf(event.target);
          if (i > -1) {
            this.index = i;
            this.track.scrollTo({ left: Math.round(this.offsetOf(i)), behavior: 'auto' });
          }
        }
      }
    );
  }
})();
